<script>
import { h, resolveComponent, toRaw } from 'vue';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/markLine';
import 'echarts/lib/component/dataZoom';
import { CHART } from '@/components/constants/chart';
import moment from 'moment';
import { useChart } from '@/composables/useChart.js';

const { setNothingChart } = useChart();

export default {
  name: 'cChart',
  components: { 'v-chart': ECharts },
  render() {
    const vChart = resolveComponent('v-chart');
    const chartBar = h(vChart, {
      ref: 'chart',
      autoresize: true,
      option: this.buildOption(),
      style: [{ width: '100%', height: '100%' }]
    });

    return h('div', { class: ['c-chart-container'] }, [
      this.$slots.default && this.$slots.default(),
      chartBar
    ]);
  },
  props: {
    items: {
      type: [Array, Object],
      default: () => {}
    },
    type: {
      type: String,
      default: 'bar'
    },
    opt: {
      type: Object,
      default: () => {}
    },
    exopt: {
      type: Object,
      default: () => {}
    },
    zoom: {
      type: Boolean,
      default: false
    },
    silent: {
      type: Boolean,
      default: false
    },
    cursor: {
      type: String,
      default: 'pointer'
    }
  },
  mounted() {
    if (this.$refs.chart) {
      this.$refs.chart.chart.on('legendselectchanged', (params) => {
        setNothingChart(params, this.$refs.chart);
      });
    }

    document.addEventListener('wheel', this.hideTooltip);
  },
  unmounted() {
    document.removeEventListener('wheel', this.hideTooltip);
  },
  methods: {
    hideTooltip: _.throttle(function () {
      if (this.$refs.chart) {
        this.$refs.chart.dispatchAction({
          type: 'hideTip'
        });
      }
    }, 500),
    buildOption() {
      const { $theme, items = [], opt } = this;
      let exopt = this.exopt || {};
      let lineStyle = {
        width: 1
      };

      exopt['stack'] = exopt['areaStyle'] ? 'total' : ''; //area style 이 null이 아닌경우에는 stacked로 판단 - jwooni
      exopt['areaStyle'] = exopt['areaStyle'] || null;
      exopt['symbol'] = exopt['symbol'] || 'circle';
      exopt['symbolSize'] = exopt['symbolSize'] || 3;
      exopt['lineStyle'] = exopt['lineStyle'] || lineStyle;

      // if (items[0].timeDiff > 30) {
      //     exopt['showSymbol'] = exopt['showSymbol'] || false;
      // }

      const colorMapping = {};
      const getColor = (name, idx) => {
        colorMapping[name] ??= $theme.COLOR.CHART[idx];
        return colorMapping[name];
      };
      const toRawSeries = items.length
        ? items.map((item, idx) => ({
            type: this.type,
            cursor: this.cursor,
            silent: this.silent,
            itemStyle: { color: getColor(item.name, idx) },
            ...exopt,
            ...item
          }))
        : items.data.map((item, idx) => ({
            itemStyle: { color: getColor(item.name, idx) },
            value: item.data,
            name: item.name,
            cursor: this.cursor,
            silent: this.silent
          }));
      //console.log(series);
      const series = toRaw(toRawSeries);

      const arrayOption = {
        series,
        ...opt
      };

      const objectOption = {
        ...opt,
        series: {
          data: series
        },
        xAxis: [{ data: _.map(!this.$util.isEmpty(items.data), 'name') }]
      };

      // minValueSpan : datazoom에서 5분 미만 드래그구간 못하게 설정
      const forceOption = {
        dataZoom: [
          {
            show: this.zoom,
            // minValueSpan: 5 * 60 * 1000,
            labelFormatter: function (value, valueStr) {
              return moment(value).format('YYYY-MM-DD HH:mm:ss').replace(' ', '\n');
            }
          }
        ],
        grid: {
          bottom: this.zoom ? 80 : this.opt.grid.bottom || 25
        }
      };

      return _.merge({}, CHART.BAR, items.length ? arrayOption : objectOption, forceOption);
    }
  }
};
</script>

<style scoped lang="scss">
.c-chart-container {
  height: 100%;
}

.c-chart {
  height: 100%;
  margin: 0 auto;
  padding: 20px;
}
</style>
